import React from 'react';
import AuthService from './authService';

// Schedule D/E online completion link (CD-5433). Served by PersonalizedWebpageController, since the record
// created is a PersonalizedWebpage - every rule lives in PersonalizedWebpage_Micro.
class OpportunityScheduleEdService extends React.Component {
  // Creates the page, emails the contact cc'ing the sender, stamps the Opportunity and writes the audit
  // comment. A prior active link is voided server-side.
  static SendLink(opportunityId, contactId) {
    const url = '/api/PersonalizedWebpage/SendOpportunityScheduleEdLinkAsync';
    const body = JSON.stringify({
      OpportunityId: Number(opportunityId),
      ContactId: Number(contactId),
    });

    return AuthService.getInstance().CallBackendFunctionPost(url, body);
  }

  // Merges the latest Schedule D/E answers into the MSA template, attaches the document and closes the
  // section (CD-5437). Whether a submission exists is checked server-side, so a rejection is a normal outcome.
  static GenerateMsa(opportunityId) {
    // The id is the whole request, so it rides the route and there is no body to send.
    const url = `/api/PersonalizedWebpage/GenerateOpportunityScheduleEdMsaAsync/${Number(opportunityId)}`;

    return AuthService.getInstance().CallBackendFunctionPost(url, null);
  }
}

export default OpportunityScheduleEdService;
